import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'
import usePageConfig, {CustomerServicePageConfigProvider} from '../hooks/use-page-config'
import CustomerServiceUserGuidesOverviewPage from './user-guides-overview'
import CustomerServiceUserGuidesBrandPage from './user-guides-brand'

const CustomerServiceUserGuidesPage = ({brands}) => {
    const {formatMessage} = useIntl()
    const {pathname, search} = useLocation()
    const pageConfig = usePageConfig()
    const searchParams = useMemo(() => new URLSearchParams(search), [search])
    const brandId = searchParams.get('brand')

    const {component: SubPage, config: subPageConfig} = useMemo(() => {
        const selectedBrand = brands?.find((brand) => brand.id === brandId)

        if (!selectedBrand) {
            return {
                component: CustomerServiceUserGuidesOverviewPage,
                config: {
                    ...pageConfig,
                    content: {
                        ...pageConfig.content,
                        params: {
                            ...pageConfig.content.params,
                            brands: brands.map((brand) => ({
                                ...brand,
                                link: `${pathname}?${new URLSearchParams({
                                    brand: brand.id
                                }).toString()}`
                            }))
                        }
                    }
                }
            }
        }

        return {
            component: CustomerServiceUserGuidesBrandPage,
            config: {
                ...pageConfig,
                pageTitle: `${selectedBrand.name} | ${pageConfig.pageTitle}`,
                name: selectedBrand.name,
                description: null,
                backLink: {
                    link: pathname,
                    label: formatMessage({
                        id: 'customer_service.user_guides.back_to_overview',
                        defaultMessage: 'Overview'
                    })
                },
                breadcrumbs: [
                    ...pageConfig.breadcrumbs,
                    {
                        link: `${pathname}?${new URLSearchParams({
                            brand: brandId
                        }).toString()}`,
                        label: selectedBrand.name
                    }
                ],
                content: {
                    ...pageConfig.content,
                    params: {
                        ...pageConfig.content.params,
                        brand: selectedBrand
                    }
                }
            }
        }
    }, [brands, brandId, pathname, pageConfig, formatMessage])

    return (
        <CustomerServicePageConfigProvider value={subPageConfig}>
            <SubPage {...subPageConfig.content.params} />
        </CustomerServicePageConfigProvider>
    )
}

CustomerServiceUserGuidesPage.propTypes = {
    brands: PropTypes.array
}

export default CustomerServiceUserGuidesPage
